module.exports = __webpack_public_path__ + "img/hr-boiler-W-fire.78aa222a.png";